import { classNames } from '@ember-decorators/component';
import Super from './_transition';
import classic from 'ember-classic-decorator';

@classic
@classNames('container')
export default class SharedSkeletonContainerContent extends Super {}
